module.exports = __webpack_public_path__ + "static/illustration-body-d-b5bf443e852d2f6c129369d2a12fdf7e.svg";